import type { CSSProperties } from 'react';
import { cn } from '@/shared/utils/cn';
import type { SectionTitlePresentationVm } from '../viewModels/newHome.vm';
import {
  buildSectionTitleStyle,
  sectionTitleFontFamilyClass,
  sectionTitleFontWeightClass,
} from './sectionTitleUtils';

interface SectionTitleProps {
  title: SectionTitlePresentationVm;
  /** Match mobile marketing typography on desktop — e.g. Shop by Category */
  variant?: 'default' | 'category';
  /** Extra classes on the `h2` (e.g. spacing / alignment overrides). */
  className?: string;
}

export default function SectionTitle({ title, variant = 'default', className }: SectionTitleProps) {
  const style: CSSProperties = buildSectionTitleStyle(title);

  const alignClass =
    title.align === 'left' ? 'text-left' : title.align === 'right' ? 'text-right' : 'text-center';

  const fontFamilyClass = sectionTitleFontFamilyClass(title);

  if (variant === 'category') {
    return (
      <p
        className={cn(
          'nh-section-title m-0 px-4 py-3 capitalize leading-none tracking-[0.01em]',
          alignClass,
          sectionTitleFontWeightClass(title.fontWeight),
          fontFamilyClass,
          title.fontStyle === 'italic' && 'italic',
          title.desktopColor && 'nh-section-title--desktop-color',
          className,
        )}
        style={style}
      >
        {title.text}
      </p>
    );
  }

  return (
    <h2
      className={cn(
        'nh-section-title px-4 py-3 text-center capitalize leading-none tracking-[0.01em] md:py-5',
        sectionTitleFontWeightClass(title.fontWeight),
        fontFamilyClass,
        title.desktopColor && 'nh-section-title--desktop-color',
        className,
      )}
      style={style}
    >
      {title.text}
    </h2>
  );
}
